import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { Notification, NotificationTypes } from './types'

export function createNotification (data: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Notification>> => {
    return Axios
      .post('/notification', data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: NotificationTypes.NOTIFICATION_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao enviar a notificação')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
        }

        return res
      })
  }
}

export function deleteNotification (id: string|number) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Notification>> => {
    return Axios
      .delete(`/notification/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: NotificationTypes.NOTIFICATION_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover a notificação')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
        }

        return res
      })
  }
}

export function updateNotification (id: string|number, data: FormData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Notification>> => {
    return Axios
      .put(`/notification/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: NotificationTypes.NOTIFICATION_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar a notificação')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
        }

        return res
      })
  }
}

export function getNotification (id: string|number) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Notification>> => {
    return Axios
      .get(`/notification/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: NotificationTypes.NOTIFICATION_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar a notificação')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getNotificationList (params?: any) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Notification[]>> => {
    return Axios
      .get('/notification', { params })
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: NotificationTypes.NOTIFICATION_GET_LIST, payload: res.data, pagination: res.pagination })
        }
        return res
      })
  }
}
